import React from "react";

const AmphrlrtIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00098 11.5764L12.0008 10.7224V7.64671L6.00098 11.5764ZM6.00098 12.3244L12.0008 17.1623V16.4088L6.00098 12.3244Z"
      fill="black"
    />
    <path
      opacity="0.8"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 11.5764L12.0002 10.7224V15.4273L18 11.5764ZM17.9999 12.3244L12 17.1623V18.9158L17.9999 12.3244Z"
      fill="black"
    />
    <g opacity="0.3">
      <path
        d="M6.00098 11.5764L12.0008 6.8719V7.64679L6.00098 11.5764Z"
        fill="black"
      />
      <path
        d="M6.00098 12.3244L12.0009 20.1022V18.9158L6.00098 12.3244Z"
        fill="black"
      />
    </g>
    <g opacity="0.2">
      <path
        d="M12.0006 2.00216V6.87176L6.00073 11.5763L12.0006 2.00216Z"
        fill="black"
      />
      <path
        d="M12.0006 6.87176L18 11.5763L12.0002 7.64664L12.0006 6.87176Z"
        fill="black"
      />
      <path
        d="M17.9999 12.3244L12.0004 20.1017L12 18.9158L6.00098 12.3244L12.0009 17.1623V18.9149L17.9999 12.3244Z"
        fill="black"
      />
      <path
        d="M6.00098 12.3244L12.0004 20.1017L12.0009 21.9976L6.00098 12.3244Z"
        fill="black"
      />
      <path
        d="M12.0008 10.7224L6.00073 11.5763L12.0008 15.4273V10.7224Z"
        fill="black"
      />
    </g>
    <g opacity="0.6">
      <path
        d="M17.9998 11.5764L12.0002 10.7224V7.64671L17.999 11.5757L12 6.87184V2.00224L17.9998 11.5764Z"
        fill="black"
      />
      <path
        d="M17.9999 12.3244L12 21.9976V20.1022L17.9999 12.3244L12.0002 17.1623V16.4088L17.9999 12.3244Z"
        fill="black"
      />
    </g>
  </svg>
);

export default AmphrlrtIcon;
